import { useQuery } from '@tanstack/react-query';

export function useApiQuery(key, fetcher, options = {}) {
  return useQuery({
    queryKey: key,
    queryFn: fetcher,
    ...options,
  });
}
